import {Component, prop, watch} from 'vue-property-decorator';
import {filtersService} from '../../filters/filters';

@Component({
    template: require('./titles.html'),
    components: {}
})
export class Titles {
    @prop(Array)
    adjustments;

    @prop(Object)
    nutrients;

    @prop(Object)
    ingredients;

    print() {
        this.$root.printing = true
    }

    save() {
        this.$emit('save');
    }

    getUnit(nutrient) {
        let unit_id = nutrient.unit_id;
        let multiplier = unit_weight_factor[unit_id];

        // Ingreds
        if (nutrient.type) {
            return '%';
        }

        if (!filtersService.weight_unit || !multiplier) {
            return nutrient.unit;
        }

        return '%';
    }
}
